/* ================= MOCK WORKERS (SHARED) ================= */

const MOCK_WORKERS = [
  // ELECTRICIANS
  {
    id: 1,
    name: "Rajesh Kumar",
    trade: "Electrician",
    exp: 8,
    rate: 900,
    rating: 4.8,
    skills: ["Wiring", "Installation", "Repair"],
    location: "Delhi",
  },
  {
    id: 2,
    name: "Suresh Patel",
    trade: "Electrician",
    exp: 6,
    rate: 800,
    rating: 4.6,
    skills: ["Maintenance", "Wiring"],
    location: "Noida",
  },
  {
    id: 3,
    name: "Amit Sharma",
    trade: "Electrician",
    exp: 10,
    rate: 1200,
    rating: 4.9,
    skills: ["Panel Setup", "Safety", "Installation"],
    location: "Gurgaon",
  },

  // PLUMBERS
  {
    id: 4,
    name: "Ravi Yadav",
    trade: "Plumber",
    exp: 7,
    rate: 700,
    rating: 4.7,
    skills: ["Pipe Fitting", "Leak Repair"],
    location: "Delhi",
  },
  {
    id: 5,
    name: "Sunil Gupta",
    trade: "Plumber",
    exp: 5,
    rate: 600,
    rating: 4.5,
    skills: ["Drainage", "Repair"],
    location: "Faridabad",
  },
  {
    id: 6,
    name: "Deepak Singh",
    trade: "Plumber",
    exp: 9,
    rate: 900,
    rating: 4.8,
    skills: ["Installation", "Maintenance"],
    location: "Ghaziabad",
  },

  // DRIVERS
  {
    id: 7,
    name: "Vikas Verma",
    trade: "Driver",
    exp: 4,
    rate: 500,
    rating: 4.3,
    skills: ["Navigation", "Delivery"],
    location: "Delhi",
  },
  {
    id: 8,
    name: "Ankit Kumar",
    trade: "Driver",
    exp: 6,
    rate: 650,
    rating: 4.6,
    skills: ["Long Route", "Navigation"],
    location: "Noida",
  },
  {
    id: 9,
    name: "Rohit Mehta",
    trade: "Driver",
    exp: 8,
    rate: 750,
    rating: 4.7,
    skills: ["Transport", "Safety"],
    location: "Gurgaon",
  },
];

export default MOCK_WORKERS;